import React from 'react'
import classnames from 'classnames'
import { exists } from '@utils/functions'

export interface NavItemProps {
  label?: string
  className?: string
  active?: boolean
  options?: string | { anchor?: string }
  onClick?: (args: any) => void
  onClickArgs?: any[]
  raw_html_label?: string
}

const NavItem: React.FC<NavItemProps> = ({
  label = '',
  className = 'tabbed-nav__list-item',
  active = false,
  options = '#',
  onClick = null,
  onClickArgs = null,
  raw_html_label,
}) => {
  const handleClick = (_event: React.MouseEvent) => {
    if (onClick) {
      onClick(onClickArgs)
    }
  }

  // Rails is smart enough to use either a string or options hash to construct the href
  const getHref = () => {
    switch (typeof options) {
      case 'string':
        return options
      case 'object':
        if (exists(options) && exists((options as any).anchor)) {
          return `#${(options as any).anchor}`
        }
        break
      default:
        break
    }
    return '#'
  }

  const getLabelContent = () => {
    if (raw_html_label) {
      return <span dangerouslySetInnerHTML={{ __html: raw_html_label }} />
    }
    return <span>{label}</span>
  }

  const classes = classnames(className, {
    current: active,
  })
  const href = getHref()
  const labelContent = getLabelContent()

  return (
    <li className={classes}>
      <a href={href} onClick={handleClick} data-testid="qa-nav-item-anchor">
        {labelContent}
      </a>
    </li>
  )
}

export default NavItem
